import noop from '@picsart/rc/noop';

import { COLLECTIONS_VIEW_STATE_TYPES } from 'components/CollectionsPopup/types';

import type { Image } from 'types/dataModels/general';

import POPUP_TYPES_ENUM from './constants';

const { ACTION, COLLECTIONS, DRIVE, TEMPLATE } = POPUP_TYPES_ENUM;

export default {
  userInfo: {
    followingUserIds: [],
    followingTags: [],
  },
  popups: {
    [ACTION]: { isOpen: false, viewState: null, data: null },
    [COLLECTIONS]: {
      isOpen: false,
      viewState: COLLECTIONS_VIEW_STATE_TYPES.COLLECTIONS,
      data: {},
    },
    [DRIVE]: {
      isOpen: false,
      data: {},
    },
    [TEMPLATE]: {
      isOpen: false,
      data: {},
    },
  },
  authPopup: { isOpen: false, data: noop },
  collections: {
    list: [],
    allSaved: null,
    selectedIds: [],
    lastSavedCollection: null,
    newCollectionData: {
      title: '',
      description: '',
      isPrivate: false,
    },
  },
  imageInfo: {} as Image,
};
